var ProductInside = {
  instances: [],

  init: function () {
    this.destroy();

    if (typeof ScrollMagic === 'undefined' || typeof gsap === 'undefined') return;

    $('[data-product-inside]').each(function () {
      ProductInside.create(this);
    });
  },

  create: function (section) {
    const $section = $(section);
    const stage = $section.find('.product-inside__stage')[0];
    const steps = $section.find('[data-product-inside-step]').toArray();
    const copies = $section.find('[data-product-inside-copy]').toArray();
    const bottle = $section.find('.product-inside__bottle')[0];
    const itemCount = steps.length;

    if (!stage || !itemCount) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setActiveItem = function (progress) {
      if (itemCount === 1 || reducedMotion) {
        ProductInside.setCopy(0, progress, copies);
        ProductInside.setImages(progress, steps);
        return;
      }

      const scaledProgress = progress * itemCount;
      const currentIndex = progress >= 1
        ? itemCount - 1
        : Math.floor(scaledProgress);
      const itemProgress = progress >= 1
        ? 1
        : scaledProgress - currentIndex;

      ProductInside.setCopy(currentIndex, itemProgress, copies);
      ProductInside.setImages(scaledProgress, steps);
    };

    if (reducedMotion) {
      ProductInside.setCopy(0, 0.2, copies);
      return;
    }

    const controller = new ScrollMagic.Controller();
    const duration = Math.max(window.innerHeight, 650) * itemCount;
    const pinOffset = stage.offsetHeight;
    let bottleOverlay = null;

    const removeBottleOverlay = function () {
      if (bottleOverlay) {
        bottleOverlay.remove();
        bottleOverlay = null;
      }

      if (bottle) {
        bottle.style.visibility = '';
      }
    };

    const updateBottleOverlay = function (isPinned) {
      if (!bottle || !isPinned) {
        removeBottleOverlay();
        return;
      }

      const bottleRect = bottle.getBoundingClientRect();

      if (!bottleOverlay) {
        bottleOverlay = bottle.cloneNode(true);
        bottleOverlay.className = 'product-inside__bottle-overlay';
        bottleOverlay.removeAttribute('loading');
        document.body.appendChild(bottleOverlay);
        bottle.style.visibility = 'hidden';
      }

      gsap.set(bottleOverlay, {
        top: bottleRect.top,
        left: bottleRect.left,
        width: bottleRect.width,
        height: bottleRect.height
      });
    };

    const scene = new ScrollMagic.Scene({
      triggerElement: stage,
      triggerHook: 1,
      offset: pinOffset,
      duration: duration
    })
      .setPin(stage, { pushFollowers: true })
      .on('progress', function (event) {
        if (event.state === 'BEFORE') {
          ProductInside.hideCopies(copies);
        } else {
          setActiveItem(event.progress);
        }

        updateBottleOverlay(event.state === 'DURING');
      })
      .addTo(controller);

    const updateBottleOverlayOnResize = function () {
      updateBottleOverlay(scene.state() === 'DURING');
    };

    window.addEventListener('resize', updateBottleOverlayOnResize);

    ProductInside.hideCopies(copies);

    const updateFirstImageEntrance = function () {
      if (scene.state() !== 'BEFORE') return;

      const stageTop = stage.getBoundingClientRect().top;
      const pinnedTop = Math.max(window.innerHeight - stage.offsetHeight, 0);
      const entranceDistance = Math.max(window.innerHeight - pinnedTop, 1);
      const entranceProgress = Math.max(
        Math.min((window.innerHeight - stageTop) / entranceDistance, 1),
        0
      );

      gsap.set(steps[0], {
        opacity: entranceProgress,
        yPercent: 65 * (1 - entranceProgress),
        visibility: 'visible'
      });
    };

    window.addEventListener('scroll', updateFirstImageEntrance, { passive: true });
    updateFirstImageEntrance();

    ProductInside.instances.push({
      controller: controller,
      scene: scene,
      onScroll: updateFirstImageEntrance,
      onResize: updateBottleOverlayOnResize,
      removeBottleOverlay: removeBottleOverlay
    });
  },

  hideCopies: function (copies) {
    copies.forEach(function (copy) {
      gsap.set(copy, {
        opacity: 0,
        y: 14,
        visibility: 'hidden'
      });

      copy.classList.remove('is-active');
    });
  },

  setImages: function (scaledProgress, steps) {
    const entranceTravel = 65;
    const exitTravel = -40;

    steps.forEach(function (step, index) {
      const imageProgress = scaledProgress - index;
      const isLast = index === steps.length - 1;
      const verticalOffset = parseFloat(step.dataset.productInsideOffset) || 0;
      let yPercent = entranceTravel;
      let opacity = 0;
      let isVisible = false;

      if (index > 0 && imageProgress >= -1 && imageProgress < 0) {
        const entranceProgress = imageProgress + 1;

        yPercent = entranceTravel * (1 - entranceProgress);
        opacity = entranceProgress;
        isVisible = true;
      } else if (imageProgress >= 0 && imageProgress <= 1) {
        yPercent = exitTravel * imageProgress;
        opacity = imageProgress < 0.45
          ? 1
          : Math.max((1 - imageProgress) / 0.55, 0);
        isVisible = true;

        if (isLast) {
          opacity = 1;
        }
      } else if (isLast && imageProgress > 1) {
        yPercent = exitTravel;
        opacity = 1;
        isVisible = true;
      }

      gsap.set(step, {
        opacity: isVisible ? opacity : 0,
        yPercent: yPercent + verticalOffset,
        visibility: isVisible ? 'visible' : 'hidden'
      });

      step.classList.toggle('is-active', isVisible);
    });
  },

  setCopy: function (currentIndex, progress, copies) {
    const isLast = currentIndex === copies.length - 1;
    const fadeIn = Math.min(progress / 0.2, 1);
    const fadeOut = !isLast && progress > 0.8
      ? Math.max((1 - progress) / 0.2, 0)
      : 1;
    const opacity = fadeIn * fadeOut;

    copies.forEach(function (copy, index) {
      const isCurrent = index === currentIndex;

      gsap.set(copy, {
        opacity: isCurrent ? opacity : 0,
        y: isCurrent ? 14 * (1 - fadeIn) - (8 * (1 - fadeOut)) : 14,
        visibility: isCurrent ? 'visible' : 'hidden'
      });

      copy.classList.toggle('is-active', isCurrent);
    });
  },

  destroy: function () {
    this.instances.forEach(function (instance) {
      window.removeEventListener('scroll', instance.onScroll);
      window.removeEventListener('resize', instance.onResize);
      instance.removeBottleOverlay();
      instance.scene.destroy(true);
      instance.controller.destroy(true);
    });

    this.instances = [];
  }
};

$(document).ready(function () {
  ProductInside.init();

  var resizeTimer;

  $(window).on('resize.productInside', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      ProductInside.init();
    }, 200);
  });
});

$(document).on('shopify:section:load', function () {
  ProductInside.init();
});

$(document).on('shopify:section:unload', function () {
  ProductInside.destroy();
});
